import { render, staticRenderFns } from "./HomeOvop.vue?vue&type=template&id=ac29a2ac&scoped=true&"
import script from "./HomeOvop.vue?vue&type=script&lang=js&"
export * from "./HomeOvop.vue?vue&type=script&lang=js&"
import style0 from "./HomeOvop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeOvop.vue?vue&type=style&index=1&id=ac29a2ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac29a2ac",
  null
  
)

export default component.exports